<template>
  <div class="learn-more row u-bg--white u-align--left">
    <div class="col-lg-6 col-xs-12 border-right">
      <div class="find-out-more">
        <simple-title :text="'En savoir plus :'"/>
        <div class="u-color--blue" v-html="content.node.more">
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-xs-12">
      <div class="contact-us">
        <simple-title :text="'Contacter l’équipe reco :'"/>
        <paragraph :text="'Pour nous faire un retour sur cet outil, ou pour tout autre question ou commentaire'"/>
        <div  @click="showModal">
          <link-contact :text="'Contacter l’équipe reco'" class="link u-color--blue"/>
        </div>
      </div>
    </div>
    <modal-contact v-show="isModalVisible"
                   @close="closeModal"
    />
  </div>
</template>

<script>
  import SimpleTitle from "../Core/SimpleTitle";
  import Paragraph from "../Core/Paragraph";
  import LinkContact from "../Core/Link/LinkContact";
  import ModalContact from "../Modal/Models/Modal-contact";

  export default {
    name: "LearnMore",
    props: ['content'],
    data () {
      return {
        isModalVisible: false,
      };
    },
    methods: {
      showModal() {
        this.isModalVisible = true;
      },
      closeModal() {
        this.isModalVisible = false;
      }
    },
    components: {ModalContact, LinkContact, Paragraph, SimpleTitle}
  }
</script>

<style lang="scss">
  .row.learn-more {
    margin: rem(30px) 0 0;
    box-shadow: 0 2px 6px 0 rgba(0,0,0,0.08);
    border: 1px solid color(border);

    .border-right {
      border-right: 1px solid color(border);

      @include mq($until: MD) {
        border-right: 0;
        border-bottom: 1px solid color(border);
      }
    }

    @media print {
      display: none;
    }

    .contact-us {
      padding: rem(35px) rem(30px) rem(45px);

      .paragraph {
        padding: rem(18px) 0;
      }

      @include mq($until: MD) {
        padding: rem(20px) rem(10px) rem(30px);
      }
    }

    .find-out-more {
      padding: rem(35px) rem(30px) rem(45px);

      ul {
        padding-left: rem(15px);
        margin-top: rem(18px);

        li {
          padding: 0 0 rem(10px) rem(20px);

          a {
            font-size: rem(14px);
            color: color(blue);
            text-decoration: underline;

            &.external-link {
              position: relative;

              &::after {
                position: absolute;
                content: '';
                background-image:url("data:image/svg+xml,%3Csvg width='14px' height='14px' viewBox='0 0 14 14' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3C!-- Generator: Sketch 51.3 (57544) - http://www.bohemiancoding.com/sketch --%3E %3Ctitle%3EIcon lien externe%3C/title%3E %3Cdesc%3ECreated with Sketch.%3C/desc%3E %3Cdefs%3E%3C/defs%3E %3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cg id='Bloc-recos' transform='translate(-220.000000, -86.000000)' fill='%230082A3'%3E %3Cg id='Group-12'%3E %3Cpath d='M232.49997,86 C232.916636,86 233.270802,86.1458331 233.562468,86.437499 C233.854133,86.7291648 233.999967,87.0833309 233.999967,87.4999964 L233.999967,98.4999702 C233.999967,98.9166357 233.854133,99.2708019 233.562468,99.5624677 C233.270802,99.8541335 232.916636,99.9999666 232.49997,99.9999666 L221.499996,99.9999666 C221.083331,99.9999666 220.729165,99.8541335 220.437499,99.5624677 C220.145833,99.2708019 220,98.9166357 220,98.4999702 L220,87.4999964 C220,87.0833309 220.145833,86.7291648 220.437499,86.437499 C220.729165,86.1458331 221.083331,86 221.499996,86 L232.49997,86 Z M232.312471,98.4999702 C232.354137,98.4999702 232.395804,98.4791368 232.43747,98.4374703 C232.479137,98.3958039 232.49997,98.3541371 232.49997,98.3124706 L232.49997,87.687496 C232.49997,87.6458296 232.479137,87.6041627 232.43747,87.5624963 C232.395804,87.5208299 232.354137,87.4999964 232.312471,87.4999964 L221.687496,87.4999964 C221.64583,87.4999964 221.604163,87.5208299 221.562496,87.5624963 C221.52083,87.6041627 221.499996,87.6458296 221.499996,87.687496 L221.499996,98.3124706 C221.499996,98.3541371 221.52083,98.3958039 221.562496,98.4374703 C221.604163,98.4791368 221.64583,98.4999702 221.687496,98.4999702 L232.312471,98.4999702 Z M230.624975,88.9999928 C230.729141,88.9999928 230.817683,89.0364513 230.890599,89.1093676 C230.963515,89.1822839 230.999974,89.2708257 230.999974,89.374992 L230.999974,93.6249818 C230.999974,93.7916479 230.921849,93.9062312 230.765599,93.968731 C230.60935,94.0312309 230.479142,93.9999809 230.374975,93.8749812 L228.843729,92.3749848 L224.34374,96.8749741 C224.28124,96.9583074 224.197906,96.9999738 224.09374,96.9999738 C223.989574,96.9999738 223.895824,96.9583074 223.812491,96.8749741 L223.124993,96.1874757 C223.041659,96.1041424 222.999993,96.0103926 222.999993,95.9062264 C222.999993,95.8020601 223.041659,95.7187268 223.124993,95.656227 L227.624982,91.1562377 L226.124985,89.6249914 C225.999986,89.5208251 225.968736,89.3906169 226.031236,89.2343673 C226.093735,89.0781177 226.208319,88.9999928 226.374985,88.9999928 L230.624975,88.9999928 Z' id='Icon-lien-externe'%3E%3C/path%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E");
                background-repeat: no-repeat;
                width: rem(14px);
                height: rem(14px);
                bottom: rem(2px);
                right: rem(-20px);
              }
            }
          }
        }
      }

      @include mq($until: MD) {
        padding: rem(20px) rem(10px) rem(30px);
      }
    }
  }

</style>
